var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0L0 13.86H16L8 0ZM8 12.61C7.52 12.61 7.13 12.22 7.13 11.74C7.13 11.26 7.52 10.87 8 10.87C8.48 10.87 8.87 11.26 8.87 11.74C8.87 12.22 8.48 12.61 8 12.61V12.61ZM8 9.58C7.52 9.58 7.13 9.19 7.13 8.71V5.25C7.13 4.77 7.52 4.38 8 4.38C8.48 4.38 8.87 4.77 8.87 5.25V8.71C8.87 9.19 8.48 9.58 8 9.58V9.58Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconError);
export default __webpack_public_path__ + "static/media/icon-error.4e944ba36460e44140b95aeea8298e68.svg";
export { ForwardRef as ReactComponent };